import { render, staticRenderFns } from "./ClienteRegistroView.vue?vue&type=template&id=5c1322b2&scoped=true"
import script from "./ClienteRegistroView.vue?vue&type=script&lang=js"
export * from "./ClienteRegistroView.vue?vue&type=script&lang=js"
import style0 from "./ClienteRegistroView.vue?vue&type=style&index=0&id=5c1322b2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c1322b2",
  null
  
)

export default component.exports